import React, { useRef, useState } from 'react';
import './nav-fixed-header.scss';

import { IClassNames, makeClassNames } from '../../../utils/styles';
import NavHeader, { INavHeader } from '../nav-header/nav-header';
import SubSectionsFiltersChips from '../../molecules/sub-sections-filters-chips/sub-sections-filters-chips';
import { ISubSection, ISubSubSection } from '../../../typings/hlroom';
import SubSectionHeader from '../../molecules/sub-section-header/SubSectionHeader';
import SubSectionsMenu from '../../molecules/sub-sections-menu/SubSectionsMenu';
import NavFiltersAll, { INavFiltersAll } from '../../molecules/nav-filters-all/nav-filters-all';
import { Grid } from '../../atoms';
import { configTemplates } from '../../templates';

export interface INavFixedHeader {
  isDesktop: boolean;
  subSections: ISubSection[];
  subSectionIndex: number;
  onSubSectionChange: (subSection: ISubSection) => void;
  onSubSubSectionChange: (subSubSection: ISubSubSection | undefined) => void;
  onNavFilterallVisibility: (value: boolean) => void;
  subSection: ISubSection;
  subSubSection?: ISubSubSection;
  noVideosByFilter?: boolean;
  videosTotal: number;
  style?: Record<string, string>;
  appType?: string;
}

const NavFixedHeader: React.FC<INavFixedHeader> = ({
  isDesktop,
  subSections,
  subSectionIndex,
  onSubSectionChange,
  onSubSubSectionChange,
  subSection,
  subSubSection,
  noVideosByFilter,
  videosTotal,
  style,
  onNavFilterallVisibility,
  appType = 'sport',
}) => {
  const elRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isVisible, setisVisible] = useState<boolean>(true);

  const handleOpenMenu = () => setIsOpen(!isOpen);

  const classNames = (isDesktop: boolean): IClassNames =>
    makeClassNames({
      navFixedHeader: [
        'nav-fixed-header',
        isDesktop && 'nav-fixed-header__desktop',
        appType && `nav-fixed-header--${appType}`,
        isDesktop && appType && `nav-fixed-header--${appType}__desktop`,
      ],
      navSubSectionsMobile: ['nav-sub-sections-mobile'],
      navFixedHeaderGrid: ['nav-fixed-header__grid', isDesktop && 'nav-fixed-header__grid__desktop'],
    });

  const propsNavHeader: INavHeader = {
    isDesktop,
    subSections,
    subSectionIndex,
    onSubSectionChange,
    allFilterVisible: !subSection.tag && isVisible,
    href:
      process.env.NODE_ENV !== 'production'
        ? configTemplates[appType].header.hrefColl
        : configTemplates[appType].header.hrefProd,
    appType,
  };

  const propsNavFilterAll: INavFiltersAll = {
    onVisibilityChange: (value: boolean) => {
      setisVisible(value);
      onNavFilterallVisibility(value);
    },
    isDesktop,
    subSections,
    onSubSectionChange,
    title: configTemplates[appType].header.title,
    description: configTemplates[appType].header.description,
    appType,
  };

  const cn = classNames(isDesktop);

  return (
    <React.Fragment>
      <div className={cn.navFixedHeader} style={{ ...style }}>
        <div className={cn.navFixedHeaderGrid} ref={elRef}>
          <NavHeader {...propsNavHeader} />
        </div>
      </div>

      {!isDesktop && !noVideosByFilter && Boolean(subSection.tag) && videosTotal > 0 && (
        <div className={cn.navSubSectionsMobile}>
          <SubSectionHeader
            onVisibilityChangeSubSection={(value: boolean) => onNavFilterallVisibility(value)}
            isDesktop={isDesktop}
            subSection={subSection}
            subSubSection={subSubSection}
            isOpen={isOpen}
            onClick={handleOpenMenu}
            noVideosByFilter={noVideosByFilter}
          />

          <SubSectionsMenu
            isDesktop={isDesktop}
            onSubSubSectionChange={onSubSubSectionChange}
            subSectionSelected={subSection}
            subSubSectionSelected={subSubSection}
            isOpen={isOpen}
            onSetIsOpen={handleOpenMenu}
            appType={appType}
          />

          {!isOpen && (
            <SubSectionsFiltersChips
              isDesktop={isDesktop}
              subSectionSelected={subSection}
              subSubSectionSelected={subSubSection}
              onSubSubSectionChange={onSubSubSectionChange}
              appType={appType}
            />
          )}
        </div>
      )}
      {!subSection.tag && !noVideosByFilter && appType === 'sport' && (
        <Grid>
          <NavFiltersAll {...propsNavFilterAll} />
        </Grid>
      )}
    </React.Fragment>
  );
};

export default NavFixedHeader;
